import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScribdComponent } from './simple-icons-scribd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScribdComponent ],
    exports:      [ SimpleIconsScribdComponent ],
    bootstrap:    []
})
export class SimpleIconsScribdModule {}
